/**
 * @generated SignedSource<<6362ce3d26a3cc55d01d5361347f777f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnerWithEmailLink_order$data = {
  readonly email: string | null;
  readonly id: string;
  readonly owner: {
    readonly name: string | null;
    readonly surname: string | null;
  } | null;
  readonly " $fragmentType": "OwnerWithEmailLink_order";
};
export type OwnerWithEmailLink_order$key = {
  readonly " $data"?: OwnerWithEmailLink_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OwnerWithEmailLink_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnerWithEmailLink_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Passenger",
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "surname",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "612d0b13ffe9f7a5dc5022b125154795";

export default node;
